// extracted by mini-css-extract-plugin
export default {"Default":"withNotification_Default__dTH+o","Body":"withNotification_Body__avLAw"};